import { Box, Center, Flex, Group, Loader, Pagination, Paper, Text, Title, useMantineTheme } from "@mantine/core";
import { UserFilter } from "../models/UserFilter";
import { User } from "../models/User";
import { convertToLocalDateTime } from "../utilities/DateUtil";

interface UserListProps {
  filterApplied: boolean;
  filters: UserFilter;
  setPageNum: (newValue: number) => void;
  totalPages: number;
  users: User[];
  totalUsers: number;
  loading: boolean;
}

export const UserList = ({
  filterApplied,
  filters,
  setPageNum,
  totalPages,
  users,
  totalUsers,
  loading
}: UserListProps) => {
  const theme = useMantineTheme();

  return (
    <>
      {filterApplied && (
        <Paper shadow="xl" p="md" my="md">
          <Group justify="center">
            <Title order={4}>Page</Title>
            <Pagination
              value={filters.pageNum + 1}
              onChange={(value) => setPageNum(value - 1)}
              total={totalPages}
              withEdges
            />
            <Text>
              Total {totalPages} pages; {users.length} users in current page;{" "}
              {totalUsers} users in total.
            </Text>
          </Group>
        </Paper>
      )}

      <Paper shadow="xl" p="md" mb="md">
        <Group
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr 0.75fr 0.75fr 0.75fr 0.75fr 1fr",
          }}
        >
          <Text span fw={700}>
            User ID
          </Text>
          <Text span fw={700}>
            Email
          </Text>
          <Text span fw={700}>
            Interview Count
          </Text>
          <Text span fw={700}>
            Device Type
          </Text>
          <Text span fw={700}>
            App Name
          </Text>
          <Text span fw={700}>
            App Version
          </Text>
          <Text span fw={700}>
            Created At
          </Text>
        </Group>
      </Paper>

      {loading ? (
        <Center h="100%">
          <Loader />
        </Center>
      ) : (
        <Flex direction="column">
          {filterApplied ? (
            users.map((user, index) => (
              <Paper key={index} shadow="xl" p="md" mb="md">
                <Group
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "1fr 2fr 0.75fr 0.75fr 0.75fr 0.75fr 1fr",
                  }}
                >
                  <Text span>{user.userId}</Text>
                  <Text span>{user.email}</Text>
                  <Text span>{user.interviewCount}</Text>
                  <Text span>{user.deviceType}</Text>
                  <Text span>{user.appName}</Text>
                  <Text span>{user.deviceVersion}</Text>
                  <Text span>{convertToLocalDateTime(user.createdAt)}</Text>
                </Group>
              </Paper>
            ))
          ) : (
            <Box mt="md" w="100%" ta="center">
              <Text w="100%" c={theme.colors.gray[7]}>
                Select some filters to see a list of users!
              </Text>
            </Box>
          )}
        </Flex>
      )}
    </>
  );
};
